import { render, staticRenderFns } from "./oliRecord.vue?vue&type=template&id=f690e732&scoped=true"
import script from "./oliRecord.vue?vue&type=script&lang=js"
export * from "./oliRecord.vue?vue&type=script&lang=js"
import style0 from "./oliRecord.vue?vue&type=style&index=0&id=f690e732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f690e732",
  null
  
)

export default component.exports